import { memo } from 'react'
import { useTranslation } from 'react-i18next'

export const Maintenance: React.FC = memo(() => {
  const { t } = useTranslation()

  return <h1> {t('navigation.maint')}</h1>
})
